"use client";

import Link from "next/link";
import { Icon } from "@iconify/react";
import { motion } from "motion/react";

export default function NotFound() {
  return (
    <section className="relative min-h-[70.5vh] -mt-16 flex items-center justify-center bg-white dark:bg-darkmode overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-hero dark:bg-darkmode transition-colors duration-300 -z-20"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 dark:bg-primary/10 rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2 -z-10 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-blue-500/5 dark:bg-blue-500/10 rounded-full blur-[80px] -translate-x-1/2 translate-y-1/2 -z-10"></div>

      <div className="container mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="relative inline-block mb-8"
        >
          <h1 className="text-[120px] md:text-[180px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary/20 to-blue-500/20 dark:from-primary/10 dark:to-blue-500/10 leading-none select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
              className="bg-white dark:bg-dark_b p-6 rounded-3xl shadow-xl border border-border dark:border-white/10"
            >
              <Icon
                icon="ion:telescope-outline"
                className="text-6xl text-primary"
              />
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-midnight_text dark:text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-lg text-muted dark:text-white/60 max-w-lg mx-auto mb-10">
            The page you're looking for isn't available. It may have been
            removed or the URL might be incorrect.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/"
              className="px-8 py-3 rounded-xl bg-primary hover:bg-danger hover:shadow-primary/25 transition-all hover:-translate-y-1 text-white font-bold hover:bg-midnight shadow-lg shadow-primary/20 flex items-center gap-2"
            >
              <Icon icon="ion:information-circle-outline" width="20" />
              About Us
            </Link>
            <Link
              href="/contact"
              className="px-8 py-3 rounded-xl border-2 border-border dark:border-white/10 text-midnight_text dark:text-white font-bold hover:bg-white dark:hover:bg-white/5 transition-colors flex items-center gap-2"
            >
              <Icon icon="ion:help-buoy-outline" width="20" />
              Contact Support
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
